import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const CHECKOUT_FORM_PRESETS_QUERY_KEY = QUERY_KEYS.getCompanyCheckoutFormPresets;

export interface CheckoutFormPresets {
  isTaxIdPtEnabledByDefault: boolean;
}

const getCompanyCheckoutFormPresets = async ({ companyId }: { companyId: string }) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/companies/${companyId}/checkout-form-presets`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompanyCheckoutFormPresets = ({
  companyId,
  options,
}: {
  companyId: string;
  options?: Record<string, boolean>;
}) => {
  return useGenericQuery<CheckoutFormPresets, RequestError>(
    [CHECKOUT_FORM_PRESETS_QUERY_KEY, companyId],
    () => getCompanyCheckoutFormPresets({ companyId }),
    options,
    true
  );
};
